<li class="nav-item">
  <a (click)="openStatusModal()" class="btn btn-info text-white me-2" href="#"><i class="fa fa-info-circle"
      aria-hidden="true"></i> {{ "deskStatus" | language }}</a>
</li>

<app-modal [id]="'deskStatusModal'">
  <span modal-title>{{ "deskStatus" | language }}</span>
  <div modal-body>
    <div class="scrolled">
      <ng-container *ngTemplateOutlet="deskStatus"></ng-container>
    </div>
  </div>
</app-modal>
<ng-template #deskStatus>
  <h5 class="pb-2 mb-0">
    <i (click)="getDeskStatus()" class="fa fa-refresh float-end" aria-hidden="true"
      [title]="'refresh' | language"></i>

  </h5>

  <div class="custom-container">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead >
          <tr>
            <th scope="col"></th>
            <th scope="col"># {{ 'desk' | language }}</th>
            <th scope="col">{{ 'zone' | language }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of desks">
                    <td class="text-center" *ngIf="d.isOnline"><i class="fa fa-circle text-success" aria-hidden="true"></i></td>
                    <td class="text-center" *ngIf="!d.isOnline"><i class="fa fa-circle text-secondary" aria-hidden="true"></i></td>
                    <td><strong>{{ d.title }}</strong></td>
                    <td>{{ d.zone }}</td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>

</ng-template>
